<div fxLayout="column" fxLayoutAlign="center center">
  <div fxFlex>
    <mat-spinner class="spinner" [diameter]="diameterSize"></mat-spinner>
  </div>
</div>
